import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataChatService } from '../../service/dataChat.service';
import { TranslateModule } from '@ngx-translate/core';
// HRS-3045: NewDetailsPage se mantiene en `imports` pero SOLO se referencia dentro del
// bloque @defer de la plantilla, así el compilador lo saca a su propio chunk (igual que
// CustomRouteComponent en chatbot-embed). No usarlo como valor en este .ts ni fuera del @defer.
import { NewDetailsPage } from "src/app/pages/new-details/new-details.page";
import { Router } from '@angular/router';

@Component({
   selector: 'app-poi-sidebar',
   standalone: true,
   imports: [
    CommonModule,
    TranslateModule,
    NewDetailsPage
],
   templateUrl: './poiSidebar.component.html',
   styleUrls: ['./poiSidebar.component.scss'],
})
export class PoiSidebarComponent {
   private router = inject(Router);
   public dataChat = inject(DataChatService);

   public itemData = computed(() => this.dataChat.poiList()?.[this.dataChat.activePoiIndex()]);

   close() {
      this.dataChat.isPoiSidebarOpen.set(false);
      this.dataChat.poiList.set([]);

   }

   next() {
      this.dataChat.activePoiIndex.update(i => Math.min(this.dataChat.poiList().length - 1, i + 1));
   }

   prev() {
      this.dataChat.activePoiIndex.update(i => Math.max(0, i - 1));
   }

   setActive(i: number) {
      this.dataChat.activePoiIndex.set(i);
   }

   navigateToDetailsPage(){
      if (!this.itemData()?.poi_url)
         return;

      this.router.navigateByUrl(this.itemData()?.poi_url);
      this.dataChat.isPoiSidebarOpen.set(false);
      this.dataChat.poiList.set([]);
   }
}
